import React from "react";
import classnames from "classnames/bind";
import { observer } from "mobx-react";

import { sendNavigationMetric } from "../../../../../utils/sendMetric";

import { useStore } from "../../../../../connect";

import strings from "../../../../../locales/strings";

import styles from "../ProfileDropdown.scss";

const cx = classnames.bind(styles);

const RecurrentPayment = () => {
  const { profile, baseUrl } = useStore();

  return (
    profile.user.recurrent_payment && (
      <div className={cx("recurrent-payment-area")}>
        <span>{strings.profile_automaticPaymentEnabled}</span>
        <a
          className={cx("glz-link")}
          target="_blank"
          rel="noopener noreferrer"
          href={`https://billing.${baseUrl}/addinvoice?utm_source=header&utm_campaign=new_header`}
          onClick={() => sendNavigationMetric("RECURRENT_PAYMENT")}
        >
          {strings.profile_settings}
        </a>
      </div>
    )
  );
};

export default observer(RecurrentPayment);
